import { useEffect, useRef } from 'react';

export const useDragHandler = ({ onMouseMove, onMouseDown, onMouseUp }) => {
  const ref = useRef(null);
  const pos = useRef(null);

  useEffect(() => {
    const ele = ref.current;
    const mouseMoveHandler = (e) => {
      const dx = e.clientX - pos.current.x;
      const dy = e.clientY - pos.current.y;
      if (onMouseMove) onMouseMove(e, ele, { dx, dy, ...pos.current });
    };
    const mouseDownHandler = function (e) {
      pos.current = {
        startX: ele.scrollLeft,
        startY: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
      if (onMouseDown) onMouseDown(e, ele);
    };

    const mouseUpHandler = function (e) {
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
      const dx = e.clientX - pos.current.x;
      const dy = e.clientY - pos.current.y;
      if (onMouseUp) onMouseUp(e, ele, { dx, dy, ...pos.current });
      pos.current = null;
    };

    // Attach the handler
    ele.addEventListener('mousedown', mouseDownHandler);
    return () => {
      ele.removeEventListener('mousedown', mouseDownHandler);
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };
  }, [ref.current]);
  return ref;
};
